import { IAppState } from '../../common/state';

export const getUserEmail = (state: IAppState): string => (state.user.isAuthenticated ? state.user.email : '');
